<template>
    <MainContent title="Listado de ventas">
        <template v-slot:header>
            <h4 class="pb-2">Listado de ventas</h4>
        </template>
        <template v-slot:content>
            <div v-if="evento" class="row">
                <div class="col-12 mb-3">
                    <h3 class="card-title">
                        EVENTO: <span>{{ evento.nombre }}</span>
                    </h3>
                </div>
                <div class="col-12">
                    <b-tabs v-model="activeTab">
                        <b-tab title="Entradas">
                            <ListadoEntradas v-if="activeTab === 0" :sesion_id="sesion_id" :evento_id="evento.id" :evento="evento" :sesiones="sesiones" />
                        </b-tab>
                        <b-tab title="Productos">
                            <ListadoProductos v-if="activeTab !== 0" :sesion_id="sesion_id" :evento="evento" :sesiones="sesiones" />
                        </b-tab>
                    </b-tabs>
                </div>
            </div>
            <LoaderComponent v-else />
        </template>
    </MainContent>
</template>

<script>
import MainContent from "@/components/backend/components/MainContent";
import ListadoEntradas from "@/components/backend/eventos/sesiones/entradas/ListadoEntradas";
import ListadoProductos from "@/components/backend/eventos/sesiones/productos/ListadoProductos";

export default {
    props: ['evento_id', 'sesion_id'],
    data() {
        return {
            activeTab: 0,
            evento: null,
            sesiones: null
        }
    },
    methods: {
        getEvent() {
            const params = {
                filters : {},
                evento_id: this.evento_id
            };
            this.$store.dispatch(this.config.getVuexAlias('back.events.show'), params).then(res => {
                this.evento = res.data.data;
                this.sesiones = res.data.data.sesiones;
            })
        },
    },
    created() {
        this.getEvent();
    },
    components: {
        MainContent, ListadoEntradas, ListadoProductos
    }
}
</script>
